export enum UserTypeRoleValueEnum {
  MANAGER = 'Gestor',
  SELLING_MANAGER = 'Gerente de vendas',
  AGENT = 'Corretor',
}
